<div class="ibox detailed-view-ibox"
     *ngIf="settingsAmenitiesService.showDetailedView && settingsAmenitiesService.selectedItemData">
    <div class="detailed-view-header">
        <span *ngIf="settingsAmenitiesService.selectedItemData.enableStatus"
              class="text-uppercase label label-active">
            Active
        </span>
        <span *ngIf="!settingsAmenitiesService.selectedItemData.enableStatus"
              class="text-uppercase label label-inactive">
            Inactive
        </span>
        <div class="detailed-view-amenity-name">{{settingsAmenitiesService.selectedItemData.name}}</div>
        <span class="close-detailed-view" (click)="settingsAmenitiesService.toggleDetailedView(null, false)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form #form="ngForm"
                  [ngClass]="{'ng-submitted': form.submitted}"
                  autocomplete="off">
                <div>
                    <div class="detailed-view-navigation">
                        <div class="col-md-3 col-sm-3 col-xs-3 no-padding">
                            <div class="button-section"
                                 (click)="changeNavPosition('general')"
                                 [ngStyle]="{'background-color': navPosition == 'general' ? '#ebebeb' : ''}">
                                General
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-3 col-xs-3 no-padding">
                            <div class="button-section"
                                 (click)="changeNavPosition('notifications')"
                                 [ngStyle]="{'background-color': navPosition == 'notifications' ? '#ebebeb' : ''}">
                                Notifications
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-3 col-xs-3 no-padding">
                            <div class="button-section"
                                 (click)="changeNavPosition('terms')"
                                 [ngStyle]="{'background-color': navPosition == 'terms' ? '#ebebeb' : ''}">
                                Terms
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-3 col-xs-3 no-padding">
                            <div class="button-section"
                                 (click)="changeNavPosition('schedule')"
                                 [ngStyle]="{'background-color': navPosition == 'schedule' ? '#ebebeb' : ''}">
                                Schedule
                            </div>
                        </div>
                    </div>
                </div>
                <div class="general-tab" *ngIf="navPosition == 'general'">
                    <input-field name="name"
                                 [ngModel]="settingsAmenitiesService.selectedItemData.name"
                                 [title]="'Name'"
                                 [tooltipText]="'Name'"
                                 (update)="onSubmit({name: form.value.name})">
                    </input-field>
                    <input-field name="internalId"
                                 [ngModel]="settingsAmenitiesService.selectedItemData.internalId"
                                 [title]="'Internal ID'"
                                 [tooltipText]="'Internal ID'"
                                 (update)="onSubmit({internalId: form.value.internalId})">
                    </input-field>
                    <hr>
                    <div>
                        <settings-amenity-uses-field name="uses"
                                                     [ngModel]="settingsAmenitiesService.selectedItemData.uses"
                                                     [title]="'Uses'"
                                                     [noEdit]="noEdit"
                                                     (update)="onSubmit({uses: form.value.uses})">
                        </settings-amenity-uses-field>
                    </div>
                    <hr>
                    <!-- ___ Images  ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-3">
                            <label>Image</label>
                        </div>
                        <div class="col-md-3 detailed-view-image">
                            <input type="file"
                                   name="amenityImage"
                                   accept=".gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff"
                                   id="add-amenity-image-img"
                                   (change)="addImage($event)"
                                   [hidden]="true"
                                   [disabled]="disabledFileInput">
                            <label for="add-amenity-image-img" class="mtv-primary-color">
                                <div class="placeholder" *ngIf="!settingsAmenitiesService.selectedItemData.amenityImage"></div>
                                <img [src]="settingsAmenitiesService.selectedItemData.amenityImage"
                                     *ngIf="settingsAmenitiesService.selectedItemData.amenityImage && !imageIsSvg()">
                                <div class="amenity-image-svg"
                                     *ngIf="settingsAmenitiesService.selectedItemData.amenityImage && imageIsSvg()"
                                     [ngStyle]="{'mask-image': 'url(' + settingsAmenitiesService.selectedItemData.amenityImage + ')',
                                                 '-webkit-mask-image': 'url(' + settingsAmenitiesService.selectedItemData.amenityImage + ')'}">
                                </div>
                            </label>
                        </div>
                        <div class="col-md-6 image-picker">
                            <i class="fa fa-chevron-left mtv-primary-color" (click)="showPreviousAmenityImage()"></i>
                            <div class="amenity-image-svg"
                                 (click)="selectPreloadedAmenityImage()"
                                 [ngStyle]="{'mask-image': 'url(' + amenityImageBasePath + displayedAmenityImage + ')',
                                             '-webkit-mask-image': 'url(' + amenityImageBasePath + displayedAmenityImage + ')'}">
                            </div>
                            <i class="fa fa-chevron-right mtv-primary-color" (click)="showNextAmenityImage()"></i>
                        </div>
                        <spinner [spinnerShow]="disabledFileInput"></spinner>
                    </div>
                    <hr>
                    <div class="settings-amenities-slider-container">
                        <span>Status</span>
                        <mat-slide-toggle name="status" (change)="onSubmit({enableStatus: form.value.status ? 1 : 0})"
                                          title="{{!settingsAmenitiesService.selectedItemData.timeSequenceType ?
                                                'Setup the booking type of this amenity to make switch active' : ''}}"
                                          [disabled]="!settingsAmenitiesService.selectedItemData.timeSequenceType"
                                          [ngModel]="settingsAmenitiesService.selectedItemData.enableStatus">
                        </mat-slide-toggle>
                    </div>
                    <hr>
                    <div class="settings-amenities-slider-container">
                        <span>Allow Residents To Book</span>
                        <mat-slide-toggle name="allowResidentsToBook"
                                          (change)="onSubmit({allowResidentsToBook: form.value.allowResidentsToBook})"
                                          [ngModel]="settingsAmenitiesService.selectedItemData.allowResidentsToBook">
                        </mat-slide-toggle>
                    </div>
                    <hr>
                    <!--<div class="settings-amenities-slider-container">-->
                        <!--<span>Allow Event Type Booking</span>-->
                        <!--<mat-slide-toggle name="allowEventTypeBooking"-->
                                          <!--(change)="onSubmit({allowEventTypeBooking: form.value.allowEventTypeBooking})"-->
                                          <!--[ngModel]="settingsAmenitiesService.selectedItemData.allowEventTypeBooking">-->
                        <!--</mat-slide-toggle>-->
                    <!--</div>-->
                    <!--<hr>-->
                    <div class="settings-amenities-slider-container">
                        <span>Requires Staff Approval</span>
                        <mat-slide-toggle name="requiresManagerApproval"
                                          (change)="onSubmit({requiresManagerApproval: form.value.requiresManagerApproval})"
                                          [ngModel]="settingsAmenitiesService.selectedItemData.requiresManagerApproval">
                        </mat-slide-toggle>
                    </div>
                    <hr>
                    <div class="settings-amenities-slider-container">
                        <span>Auto Approve After Payment</span>
                        <mat-slide-toggle name="autoApproveAfterPayment"
                                          (change)="onSubmit({autoApproveAfterPayment: form.value.autoApproveAfterPayment ? 1 : 0})"
                                          [ngModel]="settingsAmenitiesService.selectedItemData.autoApproveAfterPayment">
                        </mat-slide-toggle>
                    </div>
                    <hr>
                    <div class="m-b-xs" style="font-weight: bold;"><span>Available in Buildings</span></div>
                    <multiselect-field name="availableBuldings"
                                       [data]="settingsAmenitiesService.buldingsInMultiselectFormat"
                                       [amenityBuildingSelect]="true"
                                       [(ngModel)]="settingsAmenitiesService.selectedItemFormattedBuildingsArray"
                                       (update)="onSubmit({buildingAmenity: buildingAmenityFormatConvertion(form.value.availableBuldings)})">
                    </multiselect-field>
                    <div class="row delete-amenity-button btn-in-table" *ngIf="settingsAmenitiesService.canDelete()">
                        <button class="btn submit" type="button" (click)="deleteSelectedAmenity()">
                            Delete Amenity
                        </button>
                    </div>
                </div>
                <div *ngIf="navPosition == 'notifications'">
                    <div class="settings-amenities-slider-container">
                        <span>Notify Staff</span>
                    </div>
                    <div class="m-b-xs filter-checkbox"
                         *ngIf="!settingsAmenitiesService.selectedItemData.requiresManagerApproval">
                        <label class="img-checkbox">
                            <input type="checkbox" [(ngModel)]="settingsAmenitiesService.bookingCreatedStaffCheckbox"
                                   [disabled]="!emailTemplateIsSet('staff', 'created')"
                                   name="bookingCreatedStaffCheckbox" id="bookingCreatedStaffCheckbox"
                                   (change)="submitNotificationsField()">
                            <label for="bookingCreatedStaffCheckbox"
                                   [title]="!emailTemplateIsSet('staff', 'created') ? 'Please select email template first' : ''">
                                <svg-checked></svg-checked>
                            </label>
                        </label>
                        <span class="mtv-primary-color clickable-text"
                              (click)="showNotificationModal('staff', 'created')">
                            Booking Created
                        </span>
                    </div>
                    <div class="m-b-xs"
                         *ngIf="settingsAmenitiesService.bookingCreatedStaffCheckbox && !settingsAmenitiesService.selectedItemData.requiresManagerApproval">
                        <multiselect-field name="bookingCreatedStaffMultiselect"
                                           [data]="settingsAmenitiesService.userRoles"
                                           [(ngModel)]="settingsAmenitiesService.createdStaffMultiselectArray"
                                           (update)="submitNotificationsField()">
                        </multiselect-field>
                    </div>
                    <div class="m-b-xs filter-checkbox">
                        <label class="img-checkbox">
                            <input type="checkbox" [(ngModel)]="settingsAmenitiesService.bookingApprovedStaffCheckbox"
                                   [disabled]="!emailTemplateIsSet('staff', 'approved')"
                                   name="bookingApprovedStaffCheckbox"
                                   id="bookingApprovedStaffCheckbox"
                                   (change)="submitNotificationsField()">
                            <label for="bookingApprovedStaffCheckbox"
                                   [title]="!emailTemplateIsSet('staff', 'approved') ? 'Please select email template first' : ''">
                                <svg-checked></svg-checked>
                            </label>
                        </label>
                        <span class="mtv-primary-color clickable-text"
                              (click)="showNotificationModal('staff', 'approved')">
                            Booking Approved
                        </span>
                    </div>
                    <div class="m-b-xs" *ngIf="settingsAmenitiesService.bookingApprovedStaffCheckbox">
                        <multiselect-field name="bookingApprovedStaffMultiselect"
                                           [data]="settingsAmenitiesService.userRoles"
                                           [(ngModel)]="settingsAmenitiesService.approvedStaffMultiselectArray"
                                           (update)="submitNotificationsField()">
                        </multiselect-field>
                    </div>
                    <div class="m-b-xs filter-checkbox">
                        <label class="img-checkbox">
                            <input type="checkbox"
                                   [(ngModel)]="settingsAmenitiesService.bookingDeclinedStaffCheckbox"
                                   [disabled]="!emailTemplateIsSet('staff', 'declined')"
                                   name="bookingDeclinedStaffCheckbox"
                                   id="bookingDeclinedStaffCheckbox"
                                   (change)="submitNotificationsField()">
                            <label for="bookingDeclinedStaffCheckbox"
                                   [title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">
                                <svg-checked></svg-checked>
                            </label>
                        </label>
                        <span class="mtv-primary-color clickable-text"
                              (click)="showNotificationModal('staff', 'declined')">
                            Booking Declined
                        </span>
                    </div>
                    <div class="m-b-xs" *ngIf="settingsAmenitiesService.bookingDeclinedStaffCheckbox">
                        <multiselect-field name="bookingDeclinedStaffMultiselect"
                                           [data]="settingsAmenitiesService.userRoles"
                                           [(ngModel)]="settingsAmenitiesService.declinedStaffMultiselectArray"
                                           (update)="submitNotificationsField()">
                        </multiselect-field>
                    </div>
                    <div class="m-b-xs filter-checkbox" *ngIf="settingsAmenitiesService.selectedItemData.requiresManagerApproval">
                        <label class="img-checkbox">
                            <input type="checkbox"
                                   [(ngModel)]="settingsAmenitiesService.bookingRequestStaffCheckbox"
                                   [disabled]="!emailTemplateIsSet('staff', 'request')"
                                   name="bookingRequestStaffCheckbox"
                                   id="bookingRequestStaffCheckbox"
                                   (change)="submitNotificationsField()">
                            <label for="bookingRequestStaffCheckbox"
                                   [title]="!emailTemplateIsSet('staff', 'request') ? 'Please select email template first' : ''">
                                <svg-checked></svg-checked>
                            </label>
                        </label>
                        <span class="mtv-primary-color clickable-text"
                              (click)="showNotificationModal('staff', 'request')">
                            Booking Request
                        </span>
                    </div>
                    <div class="m-b-xs"
                         *ngIf="settingsAmenitiesService.bookingRequestStaffCheckbox && settingsAmenitiesService.selectedItemData.requiresManagerApproval">
                        <multiselect-field name="bookingRequestStaffMultiselect"
                                           [data]="settingsAmenitiesService.userRoles"
                                           [(ngModel)]="settingsAmenitiesService.requestStaffMultiselectArray"
                                           (update)="submitNotificationsField()">
                        </multiselect-field>
                    </div>
                    <hr>
                    <div class="settings-amenities-slider-container">
                        <span>Notify Residents</span>
                    </div>
                    <div class="m-b-xs filter-checkbox"
                         *ngIf="!settingsAmenitiesService.selectedItemData.requiresManagerApproval">
                        <label class="img-checkbox">
                            <input type="checkbox"
                                   id="bookingCreatedResidentCheckbox"
                                   name="bookingCreatedResidentCheckbox"
                                   [disabled]="!emailTemplateIsSet('residents', 'created')"
                                   [(ngModel)]="settingsAmenitiesService.bookingCreatedResidentCheckbox"
                                   (change)="submitNotificationsField()">
                            <label for="bookingCreatedResidentCheckbox"
                                   [title]="!emailTemplateIsSet('residents', 'created') ? 'Please select email template first' : ''">
                                <svg-checked></svg-checked>
                            </label>
                        </label>
                        <span class="mtv-primary-color clickable-text"
                              (click)="showNotificationModal('residents', 'created')">
                            Booking Created
                        </span>
                    </div>
                    <div class="m-b-xs filter-checkbox">
                        <label class="img-checkbox">
                            <input type="checkbox"
                                   id="bookingApprovedResidentCheckbox"
                                   name="bookingApprovedResidentCheckbox"
                                   [disabled]="!emailTemplateIsSet('residents', 'approved')"
                                   [(ngModel)]="settingsAmenitiesService.bookingApprovedResidentCheckbox"
                                   (change)="submitNotificationsField()">
                            <label for="bookingApprovedResidentCheckbox"
                                   [title]="!emailTemplateIsSet('residents', 'approved') ? 'Please select email template first' : ''">
                                <svg-checked></svg-checked>
                            </label>
                        </label>
                        <span class="mtv-primary-color clickable-text"
                              (click)="showNotificationModal('residents', 'approved')">
                            Booking Approved
                        </span>
                    </div>
                    <div class="m-b-xs filter-checkbox">
                        <label class="img-checkbox">
                            <input type="checkbox"
                                   id="bookingDeclinedResidentCheckbox"
                                   name="bookingDeclinedResidentCheckbox"
                                   [disabled]="!emailTemplateIsSet('residents', 'declined')"
                                   [(ngModel)]="settingsAmenitiesService.bookingDeclinedResidentCheckbox"
                                   (change)="submitNotificationsField()">
                            <label for="bookingDeclinedResidentCheckbox"
                                   [title]="!emailTemplateIsSet('residents', 'declined') ? 'Please select email template first' : ''">
                                <svg-checked></svg-checked>
                            </label>
                        </label>
                        <span class="mtv-primary-color clickable-text"
                              (click)="showNotificationModal('residents', 'declined')">
                            Booking Declined
                        </span>
                    </div>
                    <div class="m-b-xs filter-checkbox" *ngIf="settingsAmenitiesService.selectedItemData.requiresManagerApproval">
                        <label class="img-checkbox">
                            <input type="checkbox"
                                   id="bookingRequestResidentCheckbox"
                                   name="bookingRequestResidentCheckbox"
                                   [disabled]="!emailTemplateIsSet('residents', 'request')"
                                   [(ngModel)]="settingsAmenitiesService.bookingRequestResidentCheckbox"
                                   (change)="submitNotificationsField()">
                            <label for="bookingRequestResidentCheckbox"
                                   [title]="!emailTemplateIsSet('residents', 'request') ? 'Please select email template first' : ''">
                                <svg-checked></svg-checked>
                            </label>
                        </label>
                        <span class="mtv-primary-color clickable-text"
                              (click)="showNotificationModal('residents', 'request')">
                            Booking Request
                        </span>
                    </div>
                    <hr>
                    <div class="settings-amenities-slider-container">
                        <span>Reminders</span>
                    </div>
                    <div class="m-b-sm reminder-row"
                         *ngFor="let reminder of settingsAmenitiesService.selectedItemData.reminders; let index = index;">
                        <div class="clickable">
                            <label class="img-checkbox no-decoration">
                                <input id="reminderEnableStatus{{index}}"
                                       type="checkbox"
                                       [checked]="reminder.enableStatus"
                                       (change)="changeReminderStatus($event, index)">
                                <label for="reminderEnableStatus{{index}}"><svg-checked></svg-checked></label>
                            </label>
                            <span class="mtv-primary-color" (click)="editReminder(index)">{{reminder.title}}</span>
                        </div>
                        <i *ngIf="settingsAmenitiesService.selectedItemData.isCanDelete"
                           class="fa fa-trash pull-right"
                           (click)="deleteReminder(index)">
                        </i>
                    </div>
                    <i class="icon-plus pull-right"
                       (click)="settingsAmenitiesService.isRemindersModalShow = true;"
                       *ngIf="settingsAmenitiesService.selectedItemData.isCanEdit">
                    </i>
                </div>
                <div class="terms-tab" *ngIf="navPosition == 'terms'">
                   <div class="hidden">
                       <div class="m-b-xs bold"><span>User Groups Allowed</span></div>
                       <multiselect-field name="userGroups"
                                          [data]="settingsAmenitiesService.groups"
                                          [(ngModel)]="settingsAmenitiesService.selectedItemData.userGroups"
                                          (update)="onSubmit({userGroups: userGroupsFormatConvertion(form.value.userGroups)})">
                       </multiselect-field>
                   </div>
                    <div class="m-b-xs bold"><span>Occupancy Types</span></div>
                    <multiselect-field name="occupancyTypes"
                                       [data]="settingsAmenitiesService.occupancyTypesForMultiselect"
                                       [(ngModel)]="settingsAmenitiesService.selectedItemData.residentOccupancyTypes"
                                       (update)="onSubmit({residentOccupancyTypes: residentOccupancyTypesFormatConvertion(form.value.occupancyTypes)})">
                    </multiselect-field>
                    <hr>
                    <div class="settings-amenities-slider-container">
                        <span class="mtv-primary-color clickable-text"
                              (click)="settingsAmenitiesService.isLegalAgreementModalShow = true;">
                            Legal Agreement
                        </span>
                        <mat-slide-toggle name="legalAgreementStatus"
                                          (change)="onSubmit({legalAgreementStatus: form.value.legalAgreementStatus ? 1 : 0})"
                                          [ngModel]="settingsAmenitiesService.selectedItemData.legalAgreementStatus">
                        </mat-slide-toggle>
                    </div>
                    <!-- ___ Hide From Staff Interface ___ -->
                    <div class="row m-b-sm col-md-12">
                        <label class="img-checkbox no-decoration">
                            <input id="legalAgreementHideFromStaffInterface"
                                   type="checkbox"
                                   name="legalAgreementHideFromStaffInterface"
                                   [disabled]="noEdit"
                                   #legalAgreementHideFromStaffInterface
                                   [ngModel]="settingsAmenitiesService.selectedItemData.legalAgreementHideFromStaffInterface"
                                   (change)="onSubmit({legalAgreementHideFromStaffInterface: form.value.legalAgreementHideFromStaffInterface ? 1: 0})">
                            <label for="legalAgreementHideFromStaffInterface"><svg-checked></svg-checked></label>
                            <span>Hide From Staff Interface</span>
                        </label>
                    </div>
                    <hr>
                    <div class="settings-amenities-slider-container">
                        <span class="mtv-primary-color clickable-text"
                              (click)="settingsAmenitiesService.isDisclaimerModalShow = true;">
                            Disclaimer
                        </span>
                        <mat-slide-toggle name="disclaimerStatus"
                                          (change)="onSubmit({disclaimerStatus: form.value.disclaimerStatus ? 1 : 0})"
                                          [ngModel]="settingsAmenitiesService.selectedItemData.disclaimerStatus">
                        </mat-slide-toggle>
                    </div>
                    <!-- ___ Hide From Staff Interface ___ -->
                    <div class="row m-b-sm col-md-12">
                        <label class="img-checkbox no-decoration">
                            <input id="disclaimerHideFromStaffInterface"
                                   type="checkbox"
                                   name="disclaimerHideFromStaffInterface"
                                   [disabled]="noEdit"
                                   #disclaimerHideFromStaffInterface
                                   [ngModel]="settingsAmenitiesService.selectedItemData.disclaimerHideFromStaffInterface"
                                   (change)="onSubmit({disclaimerHideFromStaffInterface: form.value.disclaimerHideFromStaffInterface ? 1: 0})">
                            <label for="disclaimerHideFromStaffInterface"><svg-checked></svg-checked></label>
                            <span>Hide From Staff Interface</span>
                        </label>
                    </div>
                    <hr>
                    <div class="settings-amenities-slider-container">
                        <span class="mtv-primary-color clickable-text"
                              (click)="settingsAmenitiesService.isPaymentModalShow = true;">
                            Payments
                        </span>
                    </div>
                    <!-- ___ Accept Cheques  ___ -->
                    <div class="row m-b-sm col-md-12" *ngIf="settingsAmenitiesService.selectedItemData.fees.length">
                        <label class="img-checkbox no-decoration">
                            <input id="paymentAcceptCheques"
                                   type="checkbox"
                                   name="paymentAcceptCheques"
                                   [ngModel]="settingsAmenitiesService.selectedItemData.paymentAcceptCheques"
                                   (change)="paymentMethodSubmit({paymentAcceptCheques: form.value.paymentAcceptCheques ? 1: 0})"
                                   [disabled]="noEdit">
                            <label for="paymentAcceptCheques"><svg-checked></svg-checked></label>
                            <span>Accept Cheques</span>
                        </label>
                    </div>
                    <!-- ___ Accept Credit Cards  ___ -->
                    <div class="row m-b-sm col-md-12" *ngIf="settingsAmenitiesService.selectedItemData.fees.length">
                        <label class="img-checkbox no-decoration"
                               [title]="settingsAmenitiesService.currentAmenityCorporationHasStripeAccount ? '' : 'Corporation does not have stripe account.'">
                            <input id="paymentAcceptCreditCards"
                                   type="checkbox"
                                   name="paymentAcceptCreditCards"
                                   [ngModel]="settingsAmenitiesService.selectedItemData.paymentAcceptCreditCards"
                                   (change)="paymentMethodSubmit({paymentAcceptCreditCards: form.value.paymentAcceptCreditCards ? 1: 0})"
                                   [disabled]="noEdit || (!settingsAmenitiesService.currentAmenityCorporationHasStripeAccount && !settingsAmenitiesService.selectedItemData.customStripeAccount)">
                            <label for="paymentAcceptCreditCards"><svg-checked></svg-checked></label>
                            <span>Accept Credit Cards</span>
                        </label>
                    </div>
                    <!-- ___ Accept Cash  ___ -->
                    <div class="row m-b-sm col-md-12" *ngIf="settingsAmenitiesService.selectedItemData.fees.length">
                        <label class="img-checkbox no-decoration">
                            <input id="paymentAcceptCash"
                                   type="checkbox"
                                   name="paymentAcceptCash"
                                   [ngModel]="settingsAmenitiesService.selectedItemData.paymentAcceptCash"
                                   (change)="paymentMethodSubmit({paymentAcceptCash: form.value.paymentAcceptCash ? 1: 0})"
                                   [disabled]="noEdit">
                            <label for="paymentAcceptCash"><svg-checked></svg-checked></label>
                            <span>Accept Cash</span>
                        </label>
                    </div>
                    <!-- ___ Accept Certified cheque  ___ -->
                    <div class="row m-b-sm col-md-12" *ngIf="settingsAmenitiesService.selectedItemData.fees.length">
                        <label class="img-checkbox no-decoration">
                            <input id="paymentAcceptCertifiedCheque"
                                   type="checkbox"
                                   name="paymentAcceptCertifiedCheque"
                                   [ngModel]="settingsAmenitiesService.selectedItemData.paymentAcceptCertifiedCheque"
                                   (change)="paymentMethodSubmit({paymentAcceptCertifiedCheque: form.value.paymentAcceptCertifiedCheque ? 1: 0})"
                                   [disabled]="noEdit">
                            <label for="paymentAcceptCertifiedCheque"><svg-checked></svg-checked></label>
                            <span>Accept Certified Cheque</span>
                        </label>
                    </div>
                    <!-- ___ Accept Money Order  ___ -->
                    <div class="row m-b-sm col-md-12" *ngIf="settingsAmenitiesService.selectedItemData.fees.length">
                        <label class="img-checkbox no-decoration">
                            <input id="paymentAcceptMoneyOrder"
                                   type="checkbox"
                                   name="paymentAcceptMoneyOrder"
                                   [ngModel]="settingsAmenitiesService.selectedItemData.paymentAcceptMoneyOrder"
                                   (change)="paymentMethodSubmit({paymentAcceptMoneyOrder: form.value.paymentAcceptMoneyOrder ? 1: 0})"
                                   [disabled]="noEdit">
                            <label for="paymentAcceptMoneyOrder"><svg-checked></svg-checked></label>
                            <span>Accept Money Order</span>
                        </label>
                    </div>
                    <!-- ___ Accept Bank Draft  ___ -->
                    <div class="row m-b-sm col-md-12" *ngIf="settingsAmenitiesService.selectedItemData.fees.length">
                        <label class="img-checkbox no-decoration">
                            <input id="paymentAcceptBankDraft"
                                   type="checkbox"
                                   name="paymentAcceptBankDraft"
                                   [ngModel]="settingsAmenitiesService.selectedItemData.paymentAcceptBankDraft"
                                   (change)="paymentMethodSubmit({paymentAcceptBankDraft: form.value.paymentAcceptBankDraft ? 1: 0})"
                                   [disabled]="noEdit">
                            <label for="paymentAcceptBankDraft"><svg-checked></svg-checked></label>
                            <span>Accept Bank Draft</span>
                        </label>
                    </div>
                    <!-- ___ Accept Custom  ___ -->
                    <div class="row m-b-sm col-md-12 custom-payment-row"
                         *ngIf="settingsAmenitiesService.selectedItemData.fees.length">
                        <span class="img-checkbox no-decoration">
                            <input id="paymentAcceptCustomType"
                                   type="checkbox"
                                   name="paymentAcceptCustomType"
                                   [ngModel]="settingsAmenitiesService.selectedItemData.paymentAcceptCustomType"
                                   (change)="paymentMethodSubmit({paymentAcceptCustomType: form.value.paymentAcceptCustomType ? 1: 0})"
                                   [disabled]="noEdit">
                            <label for="paymentAcceptCustomType"><svg-checked></svg-checked></label>
                        </span>
                        <input-field name="paymentCustomTypeName"
                                     [ngModel]="settingsAmenitiesService.selectedItemData.paymentCustomTypeName"
                                     [class]="'bold'"
                                     (update)="onSubmit({paymentCustomTypeName: form.value.paymentCustomTypeName})">
                        </input-field>
                    </div>
                    <div class="row m-b-xs m-t-md"
                         *ngIf="settingsAmenitiesService.selectedItemData.fees.length"
                         (dblclick)="settingsAmenitiesService.selectedItemData.isCanEdit && setEditModeFor(settingsAmenitiesService.selectedItemData, 'defaultPaymentMethod', true)">
                        <div class="col-sm-5" style="font-weight: bold;">Default Payment Method</div>
                        <div class="col-sm-7"
                             *ngIf="!settingsAmenitiesService.selectedItemData.formFields.defaultPaymentMethod.editMode">
                            <span class="text-capitalize">{{getDefaultPaymentMethodName()}}</span>

                            <i *ngIf="settingsAmenitiesService.selectedItemData.isCanEdit"
                               class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(settingsAmenitiesService.selectedItemData, 'defaultPaymentMethod', true)"
                               data-toggle="tooltip"
                               data-placement="top"
                               title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-sm-7"
                             *ngIf="settingsAmenitiesService.selectedItemData.formFields.defaultPaymentMethod.editMode">
                            <select class="form-control"
                                    name="defaultPaymentMethod"
                                    [ngModel]="settingsAmenitiesService.selectedItemData.defaultPaymentMethod">
                                <option value="" hidden></option>
                                <option *ngIf="settingsAmenitiesService.selectedItemData.paymentAcceptCheques"
                                        value="cheque">
                                    Cheque
                                </option>
                                <option *ngIf="settingsAmenitiesService.selectedItemData.paymentAcceptCreditCards"
                                        value="credit_card">
                                    Credit Card
                                </option>
                                <option *ngIf="settingsAmenitiesService.selectedItemData.paymentAcceptCash"
                                        value="cash">
                                    Cash
                                </option>
                                <option *ngIf="settingsAmenitiesService.selectedItemData.paymentAcceptCertifiedCheque"
                                        value="certified_cheque">
                                    Certified Cheque
                                </option>
                                <option *ngIf="settingsAmenitiesService.selectedItemData.paymentAcceptMoneyOrder"
                                        value="money_order">
                                    Money Order
                                </option>
                                <option *ngIf="settingsAmenitiesService.selectedItemData.paymentAcceptBankDraft"
                                        value="bank_draft">
                                    Bank Draft
                                </option>
                                <option *ngIf="settingsAmenitiesService.selectedItemData.paymentAcceptCustomType"
                                        value="custom_type">
                                    {{settingsAmenitiesService.selectedItemData.paymentCustomTypeName}}
                                </option>
                            </select>

                            <button type="button"
                                    (click)="onSubmit({defaultPaymentMethod: form.value.defaultPaymentMethod})">
                                <i class="fa fa-check"></i>
                            </button>

                            <button type="button" (click)="setEditModeFor(settingsAmenitiesService.selectedItemData, 'defaultPaymentMethod', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <!--<settings-amenity-payments-field-->
                        <!--name="payments"-->
                        <!--[ngModel]="settingsAmenitiesService.selectedItemData.fees"-->
                        <!--(update)="onSubmit({fees: form.value.payments})">-->
                    <!--</settings-amenity-payments-field>-->
                    <!--<div class="mtv-primary-color clickable-text" style="font-weight: bold;">Credit Card Portal Setup</div>-->
                    <!--<div>acct_182Uz4J6l678Pktj</div>-->
                </div>
                <div class="schedule-tab" *ngIf="navPosition == 'schedule'">
                    <div style="font-weight: bold;">Restrictions</div>
                    <settings-amenity-restrictions-field
                        name="bookingsPerUnit"
                        [ngModel]="settingsAmenitiesService.selectedItemData.rule &&
                        settingsAmenitiesService.selectedItemData.rule['limitActivityCountBooking' + (settingsAmenitiesService.selectedItemData.timeSequenceType == 'daily' ? 'OrDays' : (settingsAmenitiesService.selectedItemData.timeSequenceType == 'hourly' ? 'OrHours' : ''))] ?
                        {number: settingsAmenitiesService.selectedItemData.rule['limitActivityCountBooking' + (settingsAmenitiesService.selectedItemData.timeSequenceType == 'daily' ? 'OrDays' : (settingsAmenitiesService.selectedItemData.timeSequenceType == 'hourly' ? 'OrHours' : ''))],
                                    selectValue: settingsAmenitiesService.selectedItemData.rule.limitActivityRangeValue} :
                        {number: null, selectValue: ''}"
                        [selectValues]="timeIntervalsPer"
                        [noEdit]="!settingsAmenitiesService.selectedItemData.timeSequenceType"
                        [title]="'Max # of Bookings Per Unit'"
                        (update)="onRestrictionsFieldSubmit(form.value.bookingsPerUnit.number, form.value.bookingsPerUnit.selectValue, 'bookingsPerUnit')">
                    </settings-amenity-restrictions-field>
                    <settings-amenity-restrictions-field
                        name="maxTimeForAdvancedBooking"
                        [ngModel]="isRestrictionsStringValid(settingsAmenitiesService.selectedItemData.maxTimeForAdvancedBooking) ?
                                {number: +settingsAmenitiesService.selectedItemData.maxTimeForAdvancedBooking.split(' ')[0],
                                 selectValue: settingsAmenitiesService.selectedItemData.maxTimeForAdvancedBooking.split(' ')[1]} :
                                {number: null, selectValue: ''}"
                        [selectValues]="timeIntervals"
                        [noEdit]="!settingsAmenitiesService.selectedItemData.timeSequenceType"
                        [title]="'Max Time for Advanced Booking'"
                        (update)="onRestrictionsFieldSubmit(form.value.maxTimeForAdvancedBooking.number, form.value.maxTimeForAdvancedBooking.selectValue, 'maxTimeForAdvancedBooking')">
                    </settings-amenity-restrictions-field>
                    <settings-amenity-restrictions-field
                        name="timeRequiredBeetween"
                        class="double-line-restrictions-field-title"
                        [ngModel]="settingsAmenitiesService.selectedItemData.rule && isRestrictionsStringValid(settingsAmenitiesService.selectedItemData.rule.minIntervalBetweenBooking) ?
                                {number: +settingsAmenitiesService.selectedItemData.rule.minIntervalBetweenBooking.split(' ')[0],
                                 selectValue: settingsAmenitiesService.selectedItemData.rule.minIntervalBetweenBooking.split(' ')[1]} :
                                {number: null, selectValue: ''}"
                        [selectValues]="timeIntervalsExt"
                        [noEdit]="!settingsAmenitiesService.selectedItemData.timeSequenceType"
                        [title]="'Time Required Between Each Booking (per Unit)'"
                        (update)="onRestrictionsFieldSubmit(form.value.timeRequiredBeetween.number, form.value.timeRequiredBeetween.selectValue, 'timeRequiredBeetween')">
                    </settings-amenity-restrictions-field>
                    <settings-amenity-restrictions-field
                        name="technicalBreak"
                        [ngModel]="settingsAmenitiesService.selectedItemData.rule && isRestrictionsStringValid(settingsAmenitiesService.selectedItemData.rule.technicalBreak) ?
                                {number: +settingsAmenitiesService.selectedItemData.rule.technicalBreak.split(' ')[0],
                                 selectValue: settingsAmenitiesService.selectedItemData.rule.technicalBreak.split(' ')[1]} :
                                {number: null, selectValue: ''}"
                        [selectValues]="timeIntervalsExt"
                        [noEdit]="!settingsAmenitiesService.selectedItemData.timeSequenceType"
                        [title]="'Time Required Between Each Booking'"
                        (update)="onRestrictionsFieldSubmit(form.value.technicalBreak.number, form.value.technicalBreak.selectValue, 'technicalBreak')">
                    </settings-amenity-restrictions-field>
                    <settings-amenity-restrictions-field
                        name="minTimeForAdvancedBooking"
                        class="double-line-restrictions-field-title"
                        [ngModel]="isRestrictionsStringValid(settingsAmenitiesService.selectedItemData.minTimeForAdvancedBooking) ?
                                {number: +settingsAmenitiesService.selectedItemData.minTimeForAdvancedBooking.split(' ')[0],
                                 selectValue: settingsAmenitiesService.selectedItemData.minTimeForAdvancedBooking.split(' ')[1]} :
                                {number: null, selectValue: ''}"
                        [selectValues]="timeIntervalsExt"
                        [noEdit]="!settingsAmenitiesService.selectedItemData.timeSequenceType"
                        [title]="'Min Time For Advanced Booking'"
                        (update)="onRestrictionsFieldSubmit(form.value.minTimeForAdvancedBooking.number, form.value.minTimeForAdvancedBooking.selectValue, 'minTimeForAdvancedBooking')">
                    </settings-amenity-restrictions-field>
                    <div class="settings-amenities-slider-container">
                        <span>Allow Double Booking For This Amenity</span>
                        <mat-slide-toggle name="multipleBooking"
                                          (change)="onSubmit({multipleBooking: form.value.multipleBooking})"
                                          [ngModel]="settingsAmenitiesService.selectedItemData.multipleBooking">
                        </mat-slide-toggle>
                    </div>
                    <input-field *ngIf="settingsAmenitiesService.selectedItemData.multipleBooking"
                                 [ngModel]="settingsAmenitiesService.selectedItemData.multipleBookingMaxCount"
                                 class="input-editable" name="name"
                                 type="number"
                                 title="Maximum of simultaneous bookings allowed"
                                 tooltipText="Number"
                                 (update)="onSubmit({multipleBookingMaxCount: form.value.name}, false)">
                    </input-field>
                    <div class="settings-amenities-slider-container">
                        <span>Allow Management Override</span>
                        <mat-slide-toggle name="managementOverride"
                                          (change)="onSubmit({managementOverride: form.value.managementOverride})"
                                          [ngModel]="settingsAmenitiesService.selectedItemData.managementOverride">
                        </mat-slide-toggle>
                    </div>
                    <hr>
                    <div style="font-weight: bold;">Scheduling</div>
                    <div>
                        <span class="mtv-primary-color clickable-text"
                              (click)="settingsAmenitiesService.isScheduleModalShow = true">
                            Booking Type
                        </span>
                        <span class="text-on-the-right">
                            <span *ngIf="!settingsAmenitiesService.selectedItemData.timeSequenceType">-</span>
                            <span *ngIf="settingsAmenitiesService.selectedItemData.timeSequenceType=='daily'">
                                Daily
                            </span>
                            <span *ngIf="settingsAmenitiesService.selectedItemData.timeSequenceType=='hourly'">
                                Hourly
                            </span>
                            <span *ngIf="settingsAmenitiesService.selectedItemData.timeSequenceType=='range'">
                                Time Range
                            </span>
                        </span>
                    </div>
                    <div>
                        <span class="mtv-primary-color clickable-text"
                              (click)="settingsAmenitiesService.isDisabledDatesModalShow = true">
                            Disabled Dates
                        </span>
                        <span class="text-on-the-right">
                            <span *ngIf="!(settingsAmenitiesService.selectedItemData.disabledDates &&
                                           settingsAmenitiesService.selectedItemData.disabledDates.length > 0)">
                                Not
                            </span> Set
                        </span>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/settings-amenities-detailed-view/settings-amenities-detailed-view.component.html